import { useEffect, useState } from "react";
import { FormPage } from "../../../common/components/form_page";
import { FieldFile } from "../../../common/components/controls/field/fieldFile";
import { textChooser } from "../../../common/util/textChooser";
import { InfoText } from "../../../common/components/info_text";
import { convertToBase64 } from "../../../common/helpers/utilities";
import { useUser } from "../../../common/hooks/User";
import { uploadDocument } from "../../../common/apis/private.api";
import { CardDocument } from "../../../common/components/card/documents";
import { useMutation, useQueryClient } from "react-query";
import { ButtonAdd } from "../../../common/components/controls/button/buttonAdd";

interface DocumentsProps { }

export const Documents = (props: DocumentsProps) => {
  const client = useQueryClient();
  const {getDataAll, refreshUserSession} = useUser();
  const { id, nameCurriculumDocument, curriculumDocumentUrl} = getDataAll();

  const [fileDocument, setFileDocument] = useState<any>();

  const {mutate, isLoading, isSuccess} = useMutation("uploadDocument", ({id, file, name}: any) => 
    uploadDocument(id, { file, name }), { onSettled: () => {
        setFileDocument(undefined);
      }
    }
  )

  const handleDocumentUpload = async () => {
    if (fileDocument) {
      const base64File = await convertToBase64(fileDocument);
      mutate({id, file: base64File, name: fileDocument.name});
    }
    client.invalidateQueries(['validate-profile'])
  } 

  const handleInputOnChangeEvent = (e: any) => {
    if (!e.target.files || e.target.files.length === 0) {
      setFileDocument(undefined);
      return;
    }

    // I've kept this example simple by using the first image instead of multiple
    setFileDocument(e.target.files[0]);
  }

  useEffect(() => {
    isSuccess && refreshUserSession()
  }, [isSuccess])

  return (
    <FormPage pageTitle={textChooser("txt118")} pageDescription={textChooser("txt119")} className="documents">
      <div className="row isCentered">
        <div className="col-xs-10 col-md-6">
          <FieldFile onChange={(e: any) => handleInputOnChangeEvent(e)} />
        </div>
        <div className="col-xs-6">
          <ButtonAdd
            type="button"
            onClick={handleDocumentUpload}
            label={isLoading ? textChooser("txt140") : textChooser("txt213")}
            disabled={isLoading}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <InfoText
            text={fileDocument?.name ?? ''}
            hidden={!fileDocument}
            type="danger"
            medium
            bold
          />
        </div>
      </div>
      {!!nameCurriculumDocument && (
        <div className="row">
          <div className="col-xs-12">
            <CardDocument 
              documentName={nameCurriculumDocument} 
              documentUrl={curriculumDocumentUrl}
            />
          </div>
        </div>
      )}
    </FormPage>
  )
}